import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TheBottomSheet',{attrs:{"title":_vm.bottomSheetTitle},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VBtn,_vm._g({attrs:{"text":"","small":"","color":"primary"}},on),[_vm._v(" "+_vm._s(_vm.dateText)+" "),_c(VIcon,[_vm._v(" mdi-calendar ")])],1)]}}]),model:{value:(_vm.sheet),callback:function ($$v) {_vm.sheet=$$v},expression:"sheet"}},[_c('DateRangeSelection',{on:{"date-change":_vm.updateDates}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }